import { useMemo } from "react";

import theme from "theme";
import { colors } from "theme/palette";

import Box from "components/Box";
import Text from "components/Text";

import { MemoSignatureTagChoices } from "./constants";

export interface IESignatureTag {
  signatureStatus: MemoSignatureTagChoices;
}

const ESignatureTag = ({ signatureStatus }: IESignatureTag) => {
  const backgroundColor = useMemo(() => {
    if (signatureStatus === MemoSignatureTagChoices.E_SIGN_ENABLED)
      return colors.gray20;
    if (signatureStatus === MemoSignatureTagChoices.E_SIGN_INITIATED)
      return colors.yellow100;
    if (signatureStatus === MemoSignatureTagChoices.E_SIGN_TERMINATED)
      return colors.red100;
    return colors.teal40;
  }, [signatureStatus]);

  return (
    <Box
      sx={{
        backgroundColor: backgroundColor,
        borderRadius: 0.5,
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        padding: theme.spacing(0.5, 1),
        width: "fit-content",
      }}
    >
      <Text
        variant="text2"
        color={
          signatureStatus === MemoSignatureTagChoices.E_SIGN_ENABLED
            ? colors.gray80
            : colors.white
        }
        fontWeight={500}
      >
        {signatureStatus}
      </Text>
    </Box>
  );
};

export default ESignatureTag;
